import { useEffect } from "react";
import { useParams, useNavigate, Outlet } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";
import { translations, type Locale } from "@/i18n/translations";

const validLocales = Object.keys(translations) as Locale[];

export const LocaleRouter = () => {
  const { lang } = useParams<{ lang: string }>();
  const { locale, setLocale } = useI18n();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang && validLocales.includes(lang as Locale)) {
      if (locale !== lang) {
        setLocale(lang as Locale);
      }
    }
  }, [lang, locale, setLocale]);

  return <Outlet />;
};

/**
 * Hook to generate locale-aware paths.
 * Usage: const localePath = useLocalePath(); localePath("/order/username")
 */
export const useLocalePath = () => {
  const { locale } = useI18n();

  return (path: string) => {
    if (locale === "en") return path;
    return `/${locale}${path}`;
  };
};
